// Postal code mappings for different countries
// Maps department/region names to postal code prefixes

export const frPostalMap: Record<string, string> = {
  'Ain': '01',
  'Aisne': '02', 
  'Allier': '03',
  'Alpes-de-Haute-Provence': '04',
  'Hautes-Alpes': '05',
  'Alpes-Maritimes': '06',
  'Ardèche': '07',
  'Ardennes': '08',
  'Ariège': '09',
  'Aube': '10',
  'Aude': '11',
  'Aveyron': '12',
  'Bouches-du-Rhône': '13',
  'Calvados': '14',
  'Cantal': '15',
  'Charente': '16',
  'Charente-Maritime': '17',
  'Cher': '18',
  'Corrèze': '19',
  "Côte-d'Or": '21',
  "Cote-d'Or": '21',
  "Côte-d'Or\n": '21',
  'Côte-d’Or': '21',
  'Côtes-d’Armor': '22',
  'Creuse': '23',
  'Dordogne': '24',
  'Doubs': '25',
  'Drôme': '26',
  'Eure': '27',
  'Eure-et-Loir': '28',
  'Finistère': '29',
  'Gard': '30',
  'Haute-Garonne': '31',
  'Gers': '32',
  'Gironde': '33',
  'Hérault': '34',
  'Ille-et-Vilaine': '35',
  'Indre': '36',
  'Indre-et-Loire': '37',
  'Isère': '38',
  'Jura': '39',
  'Landes': '40',
  'Loir-et-Cher': '41',
  'Loire': '42',
  'Haute-Loire': '43',
  'Loire-Atlantique': '44',
  'Loiret': '45',
  'Lot': '46',
  'Lot-et-Garonne': '47',
  'Lozère': '48',
  'Maine-et-Loire': '49',
  'Manche': '50',
  'Marne': '51',
  'Haute-Marne': '52',
  'Mayenne': '53',
  'Meurthe-et-Moselle': '54',
  'Meuse': '55',
  'Morbihan': '56',
  'Moselle': '57',
  'Nièvre': '58',
  'Nord': '59',
  'Oise': '60',
  'Orne': '61',
  'Pas-de-Calais': '62',
  'Puy-de-Dôme': '63',
  'Pyrénées-Atlantiques': '64',
  'Hautes-Pyrénées': '65',
  'Pyrénées-Orientales': '66',
  'Bas-Rhin': '67',
  'Haut-Rhin': '68',
  'Rhône': '69',
  'Haute-Saône': '70',
  'Saône-et-Loire': '71',
  'Sarthe': '72',
  'Savoie': '73',
  'Haute-Savoie': '74',
  'Paris': '75',
  'Seine-Maritime': '76',
  'Seine-et-Marne': '77',
  'Yvelines': '78',
  'Deux-Sèvres': '79',
  'Somme': '80',
  'Tarn': '81',
  'Tarn-et-Garonne': '82',
  'Var': '83',
  'Vaucluse': '84',
  'Vendée': '85',
  'Vienne': '86',
  'Haute-Vienne': '87',
  'Vosges': '88',
  'Yonne': '89',
  'Territoire de Belfort': '90',
  'Essonne': '91',
  'Hauts-de-Seine': '92',
  'Seine-Saint-Denis': '93',
  'Val-de-Marne': '94',
  'Val-d’Oise': '95',
  'Guadeloupe': '971',
  'Martinique': '972',
  'Guyane': '973',
  'La Réunion': '974',
  'Mayotte': '976',
  'Haute-Corse': '2B',
  'Corse-du-Sud': '2A'
};

export const esPostalMap: Record<string, string> = {
  'Álava': '01',
  'Albacete': '02',
  'Alicante/Alacant': '03',
  'Almería': '04',
  'Ávila': '05',
  'Badajoz': '06',
  'Baleares': '07',
  'Barcelona': '08',
  'Burgos': '09',
  'Cáceres': '10',
  'Cádiz': '11',
  'Castellón/Castelló': '12',
  'Ciudad Real': '13',
  'Córdoba': '14',
  'A Coruña': '15',
  'Cuenca': '16',
  'Girona': '17',
  'Granada': '18',
  'Guadalajara': '19',
  'Gipuzkoa': '20',
  'Huelva': '21',
  'Huesca': '22',
  'Jaén': '23',
  'León': '24',
  'Lérida': '25',
  'Lleida': '25',
  'La Rioja': '26',
  'Lugo': '27',
  'Madrid': '28',
  'Málaga': '29',
  'Murcia': '30',
  'Navarra': '31',
  'Orense': '32',
  'Asturias': '33',
  'Palencia': '34',
  'Las Palmas': '35',
  'Pontevedra': '36',
  'Salamanca': '37',
  'Santa Cruz de Tenerife': '38',
  'Cantabria': '39',
  'Segovia': '40',
  'Sevilla': '41',
  'Soria': '42',
  'Tarragona': '43',
  'Teruel': '44',
  'Toledo': '45',
  'Valencia/València': '46',
  'Valladolid': '47',
  'Vizcaya': '48',
  'Bizkaia': '48',
  'Zamora': '49',
  'Zaragoza': '50',
  'Ceuta': '51',
  'Melilla': '52',
  'Mallorca': '56',
  'Menorca': '56',
  'Ibiza': '56',
  'Formentera': '56',
  'Eivissa y Formentera': '56',
  'Ourense': '32'

};

export const itPostalMap: Record<string, string> = {
  'Sassari': '07',
  'Nuoro': '08',
  'Oristano': '09',
  'Cagliari': '09',
  'Sud Sardegna': '09',
  'Carbonia-Iglesias': '09',
  'Medio Campidano': '09',
  'Ogliastra': '08',
  'Olbia-Tempio': '07'
};

// Combined mapping for all countries
export const postalCodeMappings: Record<string, Record<string, string>> = {
  'FR': frPostalMap,
  'ES': esPostalMap,
  'IT': itPostalMap
};

// Helper function to get postal code mapping for a country
export const getPostalCodeMapping = (countryCode: string): Record<string, string> => postalCodeMappings[countryCode] || {};

// Helper function to get postal code for a region
export const getPostalCode = (countryCode: string, regionName: string): string | undefined => {
  const mapping = getPostalCodeMapping(countryCode);
  return mapping[regionName];
};

// Country-level mappings for entire country selection
export const countryMappings: Record<string, string> = {
  'FR': 'France',
  'ES': 'Spain', 
  'IT': 'Italy',
  'DE': 'Germany',
  'GB': 'United Kingdom',
  'PT': 'Portugal',
  'NL': 'Netherlands',
  'BE': 'Belgium',
  'CH': 'Switzerland',
  'AT': 'Austria',
  'PL': 'Poland',
  'CZ': 'Czech Republic',
  'SK': 'Slovakia',
  'HU': 'Hungary',
  'RO': 'Romania',
  'BG': 'Bulgaria',
  'HR': 'Croatia',
  'SI': 'Slovenia',
  'GR': 'Greece',
  'CY': 'Cyprus',
  'MT': 'Malta',
  'IE': 'Ireland',
  'DK': 'Denmark',
  'SE': 'Sweden',
  'FI': 'Finland',
  'NO': 'Norway',
  'IS': 'Iceland',
  'LU': 'Luxembourg',
  'EE': 'Estonia',
  'LV': 'Latvia',
  'LT': 'Lithuania'
};
